import createIcon from '../../createIcon';

/**
 * @component @name SixtyfpsSelect
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTggNVYxMUgxNVY1SDE4Wk0xOCAzSDE1QzEzLjkgMyAxMyAzLjkgMTMgNVYxMUMxMyAxMi4xIDEzLjkgMTMgMTUgMTNIMThDMTkuMSAxMyAyMCAxMi4xIDIwIDExVjVDMjAgMy45IDE5LjEgMyAxOCAzWk0xMSA1VjNINkM0LjkgMyA0IDMuOSA0IDVWMTFDNCAxMi4xIDQuOSAxMyA2IDEzSDlDMTAuMSAxMyAxMSAxMi4xIDExIDExVjlDMTEgNy45IDEwLjEgNyA5IDdINlY1SDExWk05IDlWMTFINlY5SDlaTTUgMjFIM1YxNkg1VjIxWk05IDIxSDdWMTZIOVYyMVpNMTMgMjFIMTFWMTZIMTNWMjFaTTIxIDIxSDE1VjE2SDIxVjIxWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SixtyfpsSelect = createIcon('SixtyfpsSelect', [
  [
    'path',
    {
      d: 'M18 5V11H15V5H18ZM18 3H15C13.9 3 13 3.9 13 5V11C13 12.1 13.9 13 15 13H18C19.1 13 20 12.1 20 11V5C20 3.9 19.1 3 18 3ZM11 5V3H6C4.9 3 4 3.9 4 5V11C4 12.1 4.9 13 6 13H9C10.1 13 11 12.1 11 11V9C11 7.9 10.1 7 9 7H6V5H11ZM9 9V11H6V9H9ZM5 21H3V16H5V21ZM9 21H7V16H9V21ZM13 21H11V16H13V21ZM21 21H15V16H21V21Z',
      key: 'ex099x',
    },
  ],
]);

export default SixtyfpsSelect;
